export const servicesData = [
  {
    id: "walking",
    title: "VIP Dog Walking",
    description: "Individual attention and exercise for your pup.",
    icon: "🐕",
    fullDescription: "Our VIP Dog Walking service ensures your dog gets the exercise and stimulation they need. We provide individual walks tailored to your dog's pace and energy level.",
    features: ["30 or 60 minute walks", "GPS tracking", "Photo updates", "Water refill"],
    faq: [
      {
        question: "Are these group walks?",
        answer: "We believe in quality over quantity. We never do 'pack walks' with other clients' dogs. Your time slot is exclusively for your household. If you have multiple dogs, we love walking siblings together and offer a special discounted rate for the additional pups."
      },
      {
        question: "Do you walk in bad weather?",
        answer: "We're ready to walk in any weather! That said, we want your pup to be comfortable. We can proceed with the walk (and a towel dry!), reschedule for later, or substitute the walk for some quality indoor playtime and a quick potty break. It's entirely up to you."
      }
    ]
  },
  {
    id: "waste-removal",
    title: "Waste Removal",
    description: "Regular yard cleanup to keep your lawn pristine.",
    icon: "💩",
    fullDescription: "Keep your yard clean and safe for your family and pets. We offer a white-glove service that goes beyond basic scooping.",
    features: [
      "Every inch of yard inspected",
      "Sanitizing & Deodorizing included",
      "Photo confirmation & text updates",
      "Turnkey service - no effort required"
    ],
    faq: [
      {
        question: "Do I need to be home?",
        answer: "No, as long as we have access to the yard, you don't need to be present. We'll send a photo confirmation when we're done."
      },
      {
        question: "Is there an extra charge for larger yards?",
        answer: "Our standard pricing covers most residential yards up to 1/4 acre. For larger properties, we can provide a custom quote."
      },
        {
        question: "Is there an extra charge for more than one dog?",
        answer: "Our standard pricing covers yards used by a single dog. Each additional dog adds $5 to the standard pricing."
      }
    ]
  },
  {
    id: "sleepover",
    title: "Sleepover Stays",
    description: "Premium companionship for peace of mind.",
    icon: "🏠",
    fullDescription: "Treat your dog to the ultimate luxury staycation. Our exclusive 1:1 boarding offers a premium alternative to kennels, ensuring your pet receives constant affection and the royal treatment they're accustomed to. While perfect for pampered pooches, our calm, crate-free environment is also a haven for senior dogs or those who prefer a quieter setting.",
    features: [
      "Stays in our home",
      "Walks and play throughout the day",
      "Treated like family",
      "Photo updates",
      "Couch access",
      "Backyard access",
      "Daily brushing",
      "Bath service available (add-on)",
      "No crates (unless requested)",
    ],
    note: "Pickup and drop-off service available upon request (*extra fee applies)",
    faq: [
      {
        question: "Can I book for more than one dog?",
        answer: "Yes! We can accommodate up to 2 dogs from the same family. The second dog receives a discounted rate."
      }
    ]
  },
];
